import axios from 'axios';

const CURATED_API = `${process.env.VUE_APP_API_URL}/v3/curated`;

export const getDesignerBySlug = async (slug) => {
	const { data } = await axios.get(`${CURATED_API}/designers/${slug}`);

	return data;
};
